export enum ProductStatus {
    NPI = 1,
    Active = 2,
    Discontinued = 3,
    ToBeDiscontinued = 6,
}

export const PRODUCT_STATUS_LABELS: Record<ProductStatus, string> = {
    [ProductStatus.NPI]: 'NPI',
    [ProductStatus.Active]: 'Active',
    [ProductStatus.Discontinued]: 'Discontinued',
    [ProductStatus.ToBeDiscontinued]: 'To Be Discontinued',
};

export function getProductStatusLabel(statusId: number | null | undefined): string {
    if (statusId == null) return '';
    return PRODUCT_STATUS_LABELS[statusId as ProductStatus] ?? '';
}
